import { createContext, useContext, useEffect, useMemo, useState } from 'react';
import type { ReactNode } from 'react';

import type { UserProfile } from '../types/userProfile';

type SessionContextType = {
  userProfile: Partial<UserProfile>;
  setUserProfile: (userProfile: Partial<UserProfile>) => void;
};

const SessionContext = createContext<SessionContextType>({
  userProfile: {},
  setUserProfile: () => {},
});

type SessionProviderProps = { children: ReactNode };

export function SessionProvider({ children }: SessionProviderProps) {
  const [userProfile, setUserProfile] = useState<Partial<UserProfile>>({});

  const value = useMemo(
    () => ({
      userProfile,
      setUserProfile,
    }),
    [userProfile],
  );

  return <SessionContext.Provider value={value}>{children}</SessionContext.Provider>;
}

export function useSession() {
  return useContext(SessionContext);
}

export function useIdentifySession(userProfile: UserProfile | null) {
  const { setUserProfile } = useSession();

  useEffect(() => {
    setUserProfile(userProfile ?? {});
  }, [userProfile, setUserProfile]);
}
